<script lang="ts">
    import { Button } from "sveltestrap";
    import AppWraper from "../components/AppWraper.svelte";
    import RegisterModalUnidentifiedPerson from "../components/RegisterModalUnidentifiedPerson.svelte";
    import type { RegisterUnidentifiedPerson } from "../Model/RegisterUnidentifiedPerson";
    import { recordsUnidentifiedPerson, usersService } from "../services";
    import { dateInputFormatter, dateTimeInputFormatter } from "../services/Functions";
    import { v4 as uuidv4 } from 'uuid';
    import { User } from "../Model/User";
    import FilterRegisterUnidentified from "../components/FilterRegisterUnidentified.svelte"

    let registers: any[];
    let editRegister = null;
    let offset = 0;
    let limit = 25;
    let searchFilter = {
      id : null,
      selectMotive : null,
      date : null
    };
    let user = null;

    let startDate = null;
    let endDate = null;
    let date = new Date();
    let newRegisters = false;

    $: loadInputDate();

    async function loadRegisters(searchFilter = null): Promise<void> {
        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        registers = await recordsUnidentifiedPerson.findRegisters(opts);

        user = await usersService.findActualUser();
        
    }

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        searchFilter.date = selectedDates;
        loadRegisters(JSON.stringify(searchFilter));
    }

    function newRegister(){
        newRegisters = true;

        let actualUser = new User(user);

        editRegister = {
            id: uuidv4(),
            nidentifica: null,
            fecentrada: new Date(),
            horainicio: new Date(),
            horafin: null,
            nagente: null,
            lugaridentificacion: null,
            diligenciasidentificacion: null,
            observaciones: null,
            user_id: '' + actualUser.id,
            new: true
        }
    }

    function registerUpdate(register: RegisterUnidentifiedPerson): void {
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
        }else{
            registers = [...registers, register];
        }
    }

    function editRegisterToModal(registerForEdit: RegisterUnidentifiedPerson){
        editRegister = registerForEdit;
    }

</script>

<style>

</style>

<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Registros de Personas sin identificar</h3>
                    </div>
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <div class="text-end">
                        <Button color="success" on:click={() => newRegister()}>
                            Nuevo Registro
                        </Button>
                    </div>
                </div>
            </div>

            <FilterRegisterUnidentified bind:searchFilterComponent={searchFilter} on:load={() => loadRegisters(JSON.stringify(searchFilter))}/>

            {#if registers}
            <div class="row mt-3">
                <div class="col-12">
                    {#if registers?.length}
                    <table class="table">
                        <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Nº Identificación</th>
                                    <th scope="col">Fecha Entrada</th>
                                    <th scope="col">Hora entrada</th>
                                    <th scope="col">Motivo</th>
                                </tr>
                        </thead>
                        <tbody>
                            {#each registers as register, index }
                                <tr>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        {#if register.nidentifica}
                                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                                            <span class='btn btn-link' on:click={() => {editRegisterToModal(register); newRegisters = false}}>
                                                {register.nidentifica}
                                            </span>
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.fecentrada}
                                            {dateInputFormatter(register.fecentrada)}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.horainicio}
                                            {dateTimeInputFormatter(register.horainicio)}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.motivo_nombre}
                                            {register.motivo_nombre}
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                    {:else}
                        <div class="text-center pt-5">
                            <hr>
                            <h3>No hay registros para mostrar</h3>
                        </div>
                    {/if}
                </div>
            </div>
        {/if}
        
        
        </div>
    </div>

    <RegisterModalUnidentifiedPerson register={editRegister} bind:newRegister={newRegisters} on:registerUpdate={() => registerUpdate(editRegister)}/>

</AppWraper>



